import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-badge',
  styleUrl: './badge.scss',
  templateUrl: './badge.html',
})
export class BadgeComponent {
  /** Variante visuelle (couleur) du badge. */
  readonly variant = input<BadgeVariant>('default');

  protected get cssClass(): string {
    return `ui-badge ui-badge--${this.variant()}`;
  }
}
